import styled from '@emotion/styled';
import { resolveInputFontSize } from '../TextInputStyles';
import { XMarkIcon } from '../../Icons';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledClearIcon = styled.button`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  transition: all 0.25s ease-in-out;
  cursor: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'not-allowed' : 'pointer';
}};
  svg {
    font-size: ${_ref2 => {
  let {
    theme,
    size
  } = _ref2;
  return resolveInputFontSize(theme, size);
}};
    color: currentColor;
  }
  color: ${_ref3 => {
  let {
    disabled,
    theme
  } = _ref3;
  return disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputAdornmentColor;
}};
  background-color: ${_ref4 => {
  let {
    disabled,
    theme
  } = _ref4;
  return disabled ? theme.tokens.ComponentTextInputDisabledBgColor : theme.tokens.ComponentTextInputAdornmentBg;
}};
  cursor: ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled ? 'not-allowed' : 'pointer';
}};
  &:hover {
    color: ${_ref6 => {
  let {
    disabled,
    theme
  } = _ref6;
  return disabled ? theme.tokens.ComponentTextInputDisabledColor : '';
}};
  }
  &:active {
    color: ${_ref7 => {
  let {
    disabled,
    theme
  } = _ref7;
  return disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputClearIconActiveColor;
}};
  }
  &:focus {
    color: ${_ref8 => {
  let {
    disabled,
    theme
  } = _ref8;
  return disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputClearIconFocusColor;
}};
  }
`;
export const resolveClearButton = (theme, clearButton, disabled, size, onClearButton) => {
  if (!clearButton) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledClearIcon, {
    disabled: disabled,
    onClick: onClearButton,
    theme: theme,
    size: size,
    tabIndex: -1,
    type: 'button',
    children: /*#__PURE__*/_jsx(XMarkIcon, {
      fontSize: size,
      color: theme.tokens.BaseColorGray700
    })
  });
};